<template>
  <div v-if="items">
    <b-table
      thead-tr-class="z-0"
      style="min-height: auto"
      :items="items"
      :fields="fields"
      :bordered="true"
    >
      <template #cell(attachApendix)>
        <span v-if="fields[1].key === 'appendixWarrantyCode'">Đã có PLBH</span><br />
        <span v-if="fields[1].key === 'appendixHandoverCode'">Đã có BBBG</span><br />
      </template>
      <template #cell(status)="data">
        <span
          class="badge"
          :class="
            data.item.appendixWarrantyStatus
              ? data.item.appendixWarrantyStatus
              : data.item.appendixHandoverStatus
          "
          >{{
            data.item.appendixWarrantyStatus
              ? data.item.appendixWarrantyStatus
              : data.item.appendixHandoverStatus | transformData(Config.listStatusContract)
          }}</span
        ><br />
      </template>
    </b-table>
    <slot></slot>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  export default {
    data() {
      return {
        Config,
      }
    },
    props: {
      items: {
        type: Array,
        default: () => {},
      },
      fields: {
        type: Array,
        default() {
          return [
            { key: 'attachApendix', label: 'PLBH đính kèm' },
            { key: 'appendixWarrantyCode', label: 'Mã phụ lục' },
            { key: 'status', label: 'Trạng thái PLBH', class: 'text-center' },
          ]
        },
      },
    },
  }
</script>
